<section>
  @if (variant === 'simple') {
    <!-- Simple Variant -->
    <div class="hero-section hero-section--simple" [style.background-color]="backgroundColor || null">
      <div class="hero-content hero-content--simple">
        @if (queryText && headlineBeforeQuery !== undefined && headlineAfterQuery !== undefined) {
          <!-- Headline with italic query -->
          <h1 class="hero-title" [style.color]="headerColor || null">
            <span>{{ headlineBeforeQuery }}</span><em class="hero-query-italic">"{{ queryText }}"</em><span>{{ headlineAfterQuery }}</span>
          </h1>
        } @else {
          <!-- Standard headline -->
          <h1 class="hero-title" [style.color]="headerColor || null">{{ headline | translateLang }}</h1>
        }
        @if (subtext) {
          <p class="hero-subtitle" [style.color]="subheaderColor || null">{{ subtext | translateLang }}</p>
        }
      </div>
    </div>
  } @else if (variant === 'storyAndMetrics') {
    <!-- Story and Metrics Variant -->
    <div
      #heroSection
      class="hero-section hero-section--story"
      [style.background-image]="'url(' + getBackgroundImage() + ')'"
    >
      <div class="hero-content hero-content--story">
        <div class="hero-text-container">
          <div class="hero-headline" [style.color]="headerColor || null">
            <h1 [style.color]="headerColor || null">{{ headlineProcessed[ 0 ]}}</h1>
            <h1 [style.color]="headerColor || null">{{ headlineProcessed[ 1 ]}}</h1>
            <h1 [style.color]="headerColor || null">{{ headlineProcessed[ 2 ]}}</h1>
          </div>
          @if (subtext) {
            <p class="hero-subtext" [style.color]="subheaderColor || null">{{ subtext | translateLang }}</p>
          }
        </div>
        <app-button
          class="hero-button"
          [label]="buttonLabel | translateLang"
          variant="yellow"
          (clicked)="handleButtonClick()">
        </app-button>
      </div>

      @if (stats && stats.length > 0) {
        <div #statsBanner class="stats-banner" [style.background]="statBannerBgColor || null">
          <div class="stats-content">
            @for (stat of stats; track stat.value) {
              <div class="stat-item" [style.color]="statItemColor || null">
                <div class="stat-value" [style.color]="statItemColor || null">{{ stat.value | translateLang }}</div>
                <div class="stat-label" [style.color]="statItemColor || null">{{ stat.aspect | translateLang }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>

    <div #footerPadding class="footer-padding"></div>
  } @else if (variant === 'default') {
    <!-- Default Variant -->
    <div
      #heroSection
      class="hero-section"
      [style.background-image]="'url(' + backgroundImage + ')'"
    >
      <div class="hero-content">
        <!-- <div class="eyebrow-heading">
          @if (eyebrowIcon) {
            <mat-icon
              [svgIcon]="eyebrowIcon"
              class="helping-hand-icon"
              [style.color]="eyebrowIconColor"
              [attr.aria-label]="eyebrowText">
            </mat-icon>
          }
          <span>{{ eyebrowText | translateLang | slice:0:47 }}</span>
        </div> -->
        <div>
          <h1>{{ headlineProcessed[ 0 ]}}</h1>
          <h1>{{ headlineProcessed[ 1 ]}}</h1>
          <h1>{{ headlineProcessed[ 2 ]}}</h1>
        </div>
        @if (subtext) {
          <p>{{ subtext | translateLang | slice:0:200 }}</p>
        }
        <app-button
          [label]="buttonLabel | translateLang"
          variant="yellow"
          (clicked)="handleButtonClick()">
        </app-button>
      </div>

      @if (stats && stats.length > 0) {
        <div #statsBanner class="stats">
          @for (stat of stats; track stat.value) {
            <div class="stat-data">
              <div class="value">{{ stat.value }}</div>
              <div class="aspect">{{ stat.aspect | translateLang }}</div>
            </div>
          }
        </div>
      }
    </div>

    <div #footerPadding class="footer-padding"></div>
  }
</section>
